<template>
  <b-row>
    <b-col cols="12">
      <b-form @submit.prevent>
        <b-form-group
          label="انتخاب سطح وفاداری"
          label-for="loyalty-discount-picker"
        >
          <v-select
            id="loyalty-discount-picker"
            dir="rtl"
            v-if="loyaltyDiscountList"
            :reduce="(discount) => discount.id"
            v-model="selectedLoyaltyDiscount"
            :options="loyaltyDiscountList"
            label="title"
            placeholder="سطح وفاداری را انتخاب کنید"
          >
            <template #no-options>
              هیچ سطح وفاداری جهت نمایش وجود ندارد
            </template>
          </v-select>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
export default {
  emits: ["getLoyaltyDiscountId"],
  props: {
    defaultSelectedDiscountId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  mounted() {
    this.getAllLoyaltyDiscounts();
  },
  watch: {
    selectedLoyaltyDiscount: {
      handler(val) {
        this.$emit("getLoyaltyDiscountId", val);
      },
    },
  },
  data() {
    return {
      loyaltyDiscountList: null,
      selectedLoyaltyDiscount: null,
    };
  },
  methods: {
    async getAllLoyaltyDiscounts() {
      try {
        let _this = this;
        let getAllLoyaltyDiscountsLight = new GetAllLoyaltyDiscountsLight(
          _this
        );
        await getAllLoyaltyDiscountsLight.fetch((res) => {
          _this.loyaltyDiscountList = res;
          if (_this.defaultSelectedDiscountId) {
            _this.selectedLoyaltyDiscount = _this.loyaltyDiscountList.find(
              (item) => item.id == _this.defaultSelectedDiscountId
            ).id;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
      }
    },
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
  },
};
import { BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import { GetAllLoyaltyDiscountsLight } from "@/libs/Api/ScheduleLoyaltyDiscount";
</script>
